export const contentRating = {
  family: "Family",
  youngAdult: "Young Adult",
  adult: "Adult",
  selectRating: "Select Rating",
  selectContentRating: "Select a content rating"
}
